import React, { useEffect, useState } from 'react'

import { StaticImage } from 'gatsby-plugin-image'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby'
import './premios-section.scss'
import { LOCALE, LOCALE_AT } from '../../../constants/activity-constants'
import useMediaQuery from '../../../utils/useMediaQuery'
import { WORDS } from '../../../constants/keywords'

const ImagenPremios = [].concat(getImagePremios())

function getImagePremios() {
  const imgProps = {
    alt: 'Premios',
    height: 275,
    placeholder: 'blurred',
    className: 'image  ',
  }

  return (
    <StaticImage
      src="../../../assets/images/premios/imagen-premios.png"
      {...imgProps}
    />
  )
}

function ImageLogoActividad({ isMobile }) {
  const imgProps = {
    alt: 'Logo de la actividad trivia master preguntados',
    height: 462,
    placeholder: 'blurred',
    className: '',
  }

  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/logo-actividad.png"
        {...imgProps}
        height={198}
      />
    )
  }

  return (
    <StaticImage
      src="../../../assets/images/logo-actividad.png"
      {...imgProps}
    />
  )
}
function ShowCase() {
  const [current, setCurrent] = useState(0)
  useEffect(() => {
    let page = 0
    let total = ImagenPremios.length - 1
    let interval = 0
    if (total < 2) {
      return
    }
    const disappear_time = 1000
    const standing_time = 3000
    const dissappear = () => {
      let imagewrapper = document.querySelector('.f-premios-section__showcase')
      if (!imagewrapper) {
        return Promise.resolve()
      }
      imagewrapper.classList.add('disappear')
      return waitTime(disappear_time).then(() => {
        imagewrapper.classList.remove('disappear')
      })
    }
    const waitTime = (time = 1000) => {
      return new Promise(resolve => {
        interval = setTimeout(resolve, time)
      })
    }
    const waitToFade = () => {
      return waitTime(standing_time).then(() => {
        return dissappear()
      })
    }
    const next = () => {
      page++
      if (page > total) {
        page = 0
      }
      setCurrent(page)
      waitToFade().then(() => {
        next()
      })
    }
    waitToFade().then(() => {
      next()
    })

    return () => {
      clearInterval(interval)
    }
  }, [])
  return (
    <div className={'f-premios-section__showcase '}>
      {ImagenPremios[current]}
    </div>
  )
}
function ActivityImageWrapper() {
  useEffect(() => {
    const unbinds = {}

    let do_rotation = true
    let do_shine = true
    let do_spark = true
    const random = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    const timeOutUntil = (callback, time = 1000) => {
      let id = setTimeout(callback, time)
      unbinds[id] = () => {
        clearTimeout(id)
        unbinds[id] = null
        delete unbinds[id]
      }
    }
    const fadeInRotate = (element, dist, time, callback) => {
      let ang = random(0, 360)
      let scale = random(8, 22) / 10
      element.style.transform = `rotate(${ang}deg) translate(${dist}px,${0}px) scale(${scale})`
      element.style.animation = `fade-in ${time / 1000}s ease-in-out both`
      timeOutUntil(() => {
        element.style.animation = `fade-out ${time / 1000}s ease-in-out both`
        timeOutUntil(callback, time)
      }, time)
    }

    let mainInterval = setInterval(() => {
      let rulette = document.getElementById('rulette')
      let shines = document.getElementById('shines')
      let sparks = document.getElementById('sparks')
      if (do_rotation) {
        do_rotation = false
        let ang = random(45, 360) * 5
        rulette.style.transform = `rotate(${ang}deg)`
        timeOutUntil(() => {
          rulette.style.transform = `rotate(0deg)`
          timeOutUntil(() => {
            do_rotation = true
          }, 3200)
        }, 3200)
      }
      if (do_shine) {
        do_shine = false
        fadeInRotate(shines, 160, 600, () => {
          do_shine = true
        })
      }
      if (do_spark) {
        do_spark = false
        fadeInRotate(sparks, 160, 400, () => {
          do_spark = true
        })
      }
    }, 100)

    return () => {
      clearInterval(mainInterval)
      for (let i in unbinds) {
        unbinds[i]()
      }
    }
  }, [])
  return (
    <div className="f-premios-section__media-wrapper">
      <div className="f-premios-section__media-wrapper__background">
        <div
          id="rulette"
          className="f-premios-section__media-wrapper__prizes"
        ></div>
        <div className="f-premios-section__media-wrapper__arrow"></div>
        <div className="f-premios-section__media-wrapper__circle_logo"></div>

        <div id="shines" className="f-premios-section__media-wrapper__shines" />
        <div id="sparks" className="f-premios-section__media-wrapper__sparks" />
      </div>
    </div>
  )
}
function ImageBase() {
  const imgProps = {
    alt:
      'la ruleta que es la imagen de la actividad  trivia  master preguntados',
    height: 405,
    placeholder: 'blurred',
    className: 'image  rueda-fondo',
  }

  return (
    <div className="--baseWrapper">
      <StaticImage
        src="../../../assets/images/premios/base-premios.png"
        {...imgProps}
      />
      <i>Imágenes de referencia*</i>
    </div>
  )
}
function TransitionPremios() {
  return (
    <div className="f-premios-section__stage-wrapper flex --column">
      <ShowCase />
      <ImageBase />
    </div>
  )
}
function Title() {
  return (
    <>
      <b>¿Qué tanto sabes de Nosotras®?</b>
    </>
  )
}
function PinkPhrase() {
  return null
}
function Phrase1() {
  return (
    <p>
      Llegó el momento de demostrar tu conocimiento, responde las preguntas,
      desbloquea las insignias y gana premios.
      <br />
    </p>
  )
}
function Phrase2() {
  // if (SHOW_STORE_PACKAGE_MESSAGE) {
  return (
    <>
      <p className="--pink-bold --small">
        Sé una de las 10 ganadoras de 1 kit descargable con paso a paso para
        crear tu mapa de sueños + plantillas + imágenes inspiradoras + stickers
        y frases
      </p>
    </>
  )
  // }
  // return null
}

function CallToActionText() {
  if (LOCALE_AT.ARGENTINA || LOCALE_AT.PARAGUAY || LOCALE_AT.URUGUAY) {
    return <>Participá ya</>
  }
  return <>¡a jugar!</>
}

export default function PremiosSection({ id }) {
  const isMobile = useMediaQuery()
  return (
    <section className={'f-premios-section '} id={id}>
      <div className="f-premios-section__wrapper">
        <div className="f-premios-section__center section-logo flex --column">
          <ImageLogoActividad isMobile={isMobile} />
          {isMobile ? null : (
            <Button
              className="violeta-rosa"
              tag="7A"
              onClick={() => {
                navigate('/play')
              }}
            >
              <CallToActionText />
            </Button>
          )}
        </div>
        <aside className="f-premios-section__aside section-ruleta --media flex --column">
          <ActivityImageWrapper />
        </aside>
        <aside className="f-premios-section__aside section-box">
          <div className="f-premios-section__card">
            <h2 className={`--loc-${LOCALE.toLowerCase()}`}>
              <Title />
            </h2>
            <PinkPhrase />
            <Phrase1 />
            <Phrase2 />
          </div>

          <TransitionPremios />
          {isMobile ? (
            <Button
              className="violeta-rosa"
              tag="7A"
              onClick={() => {
                navigate('/play')
              }}
            >
              <CallToActionText />
            </Button>
          ) : null}
        </aside>
      </div>
    </section>
  )
}
